import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { t } from '$i18n'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'

const StyledTypography = styled(Typography)`
  margin-right: 4px;
  display: contents;
`

export function PrivateSpaceListItemTitle() {
  return (
    <WithQueryTitleWrapper>
      <StyledTypography variant="subtitle3" noWrap>
        {t('chatList.privateSpace')}
      </StyledTypography>
    </WithQueryTitleWrapper>
  )
}
